export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'd8ed9540-c0a3-4f61-824a-fae2c8c13fca';
export const MODAL_CLOSE_SEC = 2.5;
